// ONE OF THE PERSON'S APPS in the builder's sidebar (pages/add-app.js; Nika
// 2026-10-23: "make sidebar more appealing and beautiful"): the house rail row
// (AppSidebarRow — its washes, its active row, its meta in the right ink on
// every wash) for an app — its glyph, its name, when it last changed. The app
// the conversation is building is the active row (and the current one for
// assistive technology). A press opens that app's thread and its build
// (functions/addAppSidebar.js addAppSidebarPick). The row's state is
// addAppSidebarRows' row; it holds no logic of its own.
export const AddAppSidebarRow = {
  extends: 'AppSidebarRow',
  isActive: (el, s) =>
    !!s && !!s.id && String((s.root && s.root._addAppProjectId) || '') === String(s.id),
  ariaCurrent: (el, s) =>
    s && s.id && String((s.root && s.root._addAppProjectId) || '') === String(s.id) ? 'true' : null,
  title: (el, s) => (s && s.label) || null,
  onClick: (e, el, s) => el.call('addAppSidebarPick', s && s.id)
}
